import React, { useState, useEffect } from 'react';
import Globals from '../Globals';
import { HashLink } from 'react-router-hash-link';
import DepartureCalculator from './DepartureCalcul';

const API = Globals.API;

const T = {
 pageTitle: { fontFamily:"'Inter', sans-serif", fontWeight: 700, color: '#01225C' },
 pageSubtitle: { fontFamily:"'Inter', sans-serif", fontWeight: 400, color: '#00338C' },
 cardTitle: { fontFamily:"'Playfair Display', serif", fontWeight: 700, color: '#01225C' },
 cardDesc: { fontFamily:"'Inter', sans-serif", fontWeight: 400, color: '#6C757D', lineHeight: '1.7' },
 label: { fontFamily:"'Inter', sans-serif", fontWeight: 400, color: '#6C757D' },
 base: { fontFamily:"'Inter', sans-serif" },
};

export default function Omra() {
 const [events, setEvents] = useState([]);
 const [loading, setLoading] = useState(true);
 const [selectedEvent, setSelectedEvent] = useState(null);
 const [showModal, setShowModal] = useState(false);
 const [selectedDestination, setSelectedDestination] = useState('all');
 const [destinations, setDestinations] = useState([]);


 useEffect(() => {
 const urlParams = new URLSearchParams(window.location.search);
 if (urlParams.get('success') === 'true') {
 setTimeout(() => window.history.replaceState({}, '', window.location.pathname), 5000);
 }
 fetchEvents();
 }, []);

 const fetchEvents = async () => {
 try {
 const response = await fetch(`${API}/events`);
 const result = await response.json();
 if (result.success) {
 const omraEvents = result.data.filter(e => e.category === 'omra' && e.isActive);
 setEvents(omraEvents);
 setDestinations([...new Set(omraEvents.map(e => e.destination))]);
 }
 } catch (err) {
 console.error(err);
 } finally {
 setLoading(false);
 }
 };

 const openModal = (event) => { setSelectedEvent(event); setShowModal(true); };
 const closeModal = () => { setShowModal(false); setSelectedEvent(null); };

 const filteredEvents = selectedDestination === 'all'
 ? events
 : events.filter(e => e.destination === selectedDestination);

 return (
 <div style={T.base}>
 <style>{css}</style>

 {/* ══ MODAL ══ */}
 {showModal && selectedEvent && (
 <div className="omra-modal-backdrop" onClick={closeModal}>
 <div className="omra-modal-dialog" onClick={e => e.stopPropagation()}>
 <div className="omra-modal-header">
 <h5 className="omra-modal-header__title">
 <i className="fa fa-kaaba me-2" />{selectedEvent.title}
 </h5>
 <button className="omra-modal-close" onClick={closeModal}>✕</button>
 </div>
 <div className="omra-modal-body">
 <div className="omra-modal-img-wrap">
 <img src={selectedEvent.image} alt={selectedEvent.title} className="omra-modal-img" />
 <div className="omra-modal-img-overlay">
 <span><i className="fa fa-map-marker-alt me-1" />{selectedEvent.destination}</span>
 </div>
 </div>
 {selectedEvent.departureDates?.map((departure, idx) => {
 const pricing = departure.pricing?.b2c || {};
 const isComplet = !departure.isAvailable || departure.availableSeats === 0;
 return (
 <div key={idx} className="omra-modal-departure">
 <div className="omra-modal-departure__header">
 <div>
 <strong style={{ color: '#00338C' }}>
 <i className="fa fa-plane-departure me-2" />
 Départ : {new Date(departure.departureDate).toLocaleDateString('fr-FR')}
 </strong><br />
 <strong style={{ color: '#00338C' }}>
 <i className="fa fa-plane-arrival me-2" />
 Retour : {new Date(departure.returnDate).toLocaleDateString('fr-FR')}
 </strong>
 </div>
 <span className={`omra-badge ${isComplet ? 'omra-badge--red' : 'omra-badge--green'}`}>
 {isComplet ? 'Complet' : `${departure.availableSeats} places disponibles`}
 </span>
 </div>
 <div className="omra-modal-pricing">
 {pricing.price != null && <div className="omra-price-item"><strong>Prix standard :</strong> {pricing.price} TND</div>}
 {pricing.tarifdemidouble != null && <div className="omra-price-item"><strong>Demi-double :</strong> {pricing.tarifdemidouble} TND</div>}
 {pricing.spplementsingle != null && <div className="omra-price-item"><strong>Supplément single :</strong> {pricing.spplementsingle} TND</div>}
 {pricing.enf2_6 != null && <div className="omra-price-item"><strong>Enfant 2–6 ans :</strong> {pricing.enf2_6} TND</div>}
 {pricing.enf6_12 != null && <div className="omra-price-item"><strong>Enfant 6–12 ans :</strong> {pricing.enf6_12} TND</div>}
 </div>
 <DepartureCalculator departure={departure} />
 </div>
 );
 })}
 <div className="omra-modal-section">
 <h5 className="omra-modal-section__title"><i className="fa fa-info-circle me-2" />Description</h5>
 <p style={T.cardDesc}>{selectedEvent.description}</p>
 </div>
 {selectedEvent.program && (
 <div className="omra-modal-section">
 <h5 className="omra-modal-section__title"><i className="fa fa-list-ul me-2" />Programme</h5>
 <div className="omra-modal-program">
 {selectedEvent.program.split('\\n').map((line, i) => (
 <p key={i}><i className="fa fa-check text-success me-2" />{line}</p>
 ))}
 </div>
 </div>
 )}
 {selectedEvent.voldetails && (
 <div className="omra-modal-section">
 <h5 className="omra-modal-section__title"><i className="fa fa-plane-departure me-2" />Détails du Vol</h5>
 <div className="omra-modal-vol">{selectedEvent.voldetails}</div>
 </div>
 )}
 </div>
 <div className="omra-modal-footer">
 <button className="omra-btn omra-btn--ghost" onClick={closeModal}>Fermer</button>
 <HashLink
 to={selectedEvent?.isActive ? '/#res' : '#'}
 className={`omra-btn ${selectedEvent?.isActive ? 'omra-btn--primary' : 'omra-btn--disabled'}`}
 onClick={selectedEvent?.isActive ? closeModal : undefined}
 style={{ pointerEvents: selectedEvent?.isActive ? 'auto' : 'none' }}
 >
 <i className="fa fa-calendar-check me-2" />
 {selectedEvent?.isActive ? 'Réserver Maintenant' : 'Événement complet'}
 </HashLink>
 </div>
 </div>
 </div>
 )}

 {/* ══ BANNER ══ */}
 <div className="omra-banner">
 <div className="omra-banner__overlay" />
 <div className="omra-banner__content">
 <h1 className="omra-banner__title">Omra 2025</h1>
 <p className="omra-banner__sub">Accomplissez votre voyage spirituel en toute sérénité</p>
 </div>
 </div>

 {/* ══ MAIN ══ */}
 <div className="omra-section">
 <div className="omra-section__header">
 <h1 style={T.pageTitle}>Packages Omra 2025</h1>
 <p style={T.pageSubtitle}>Des forfaits complets pour un voyage spirituel inoubliable</p>
 </div>

 {!loading && events.length > 0 && (
 <div className="omra-filter">
 <span className="omra-filter__label">
 <i className="fa fa-filter me-2" />Filtrer par destination :
 </span>
 <select
 className="omra-filter__select"
 value={selectedDestination}
 onChange={e => setSelectedDestination(e.target.value)}
 >
 <option value="all">Toutes les destinations ({events.length})</option>
 {destinations.map((d, i) => (
 <option key={i} value={d}>{d} ({events.filter(e => e.destination === d).length})</option>
 ))}
 </select>
 </div>
 )}

 {loading ? (
 <div className="omra-loading">
 <div className="omra-spinner" />
 <p style={T.label}>Chargement des offres Omra...</p>
 </div>
 ) : filteredEvents.length === 0 ? (
 <div className="omra-empty">
 <i className="fa fa-kaaba fa-3x omra-empty__icon" />
 <p style={T.cardDesc}>
 {selectedDestination === 'all'
 ? 'Aucune offre Omra disponible pour le moment.'
 : `Aucune offre disponible pour ${selectedDestination}.`}
 </p>
 </div>
 ) : (
 <div className="omra-cards">
 {filteredEvents.map((event) => {
 const price = event.departureDates?.[0]?.pricing?.b2c?.price;
 return (
 <div key={event._id} className="omra-card">

 {/* Col 1 — Image */}
 <div className="omra-card__img-wrap">
 <img src={event.image} alt={event.title} className="omra-card__img" />
 <div className="omra-card__img-gradient" />
 </div>

 {/* Col 2 — Contenu */}
 <div className="omra-card__content">
 <h3 className="omra-card__title" style={T.cardTitle}>{event.title}</h3>
 <p className="omra-card__desc" style={T.cardDesc}>
 {event.description.length > 180
 ? `${event.description.substring(0, 180)}...`
 : event.description}
 </p>

 {/* Services inclus */}
 <div className="omra-card__services">
 <span className="omra-card__services-left">
 <i className="fa fa-th-list omra-card__services-icon" />
 <span className="omra-card__services-text">Services inclus</span>
 </span>
 <span className="omra-card__services-count">
 {event.includedServices.length} services
 </span>
 </div>

 {/* Votre Voyage Inclut — label ligne 1, icônes ligne 2 */}
 <div className="omra-card__includes">
 <span className="omra-card__includes-label">Votre Voyage Inclut</span>
 <div className="omra-card__includes-icons">
 <span className="omra-card__icon-circle" title="Vol"><i className="fa fa-plane" /></span>
 <span className="omra-card__icon-circle" title="Hébergement"><i className="fa fa-hotel" /></span>
 <span className="omra-card__icon-circle" title="Remise"><i className="fa fa-percent" /></span>
 </div>
 </div>
 </div>

 {/* Col 3 — Prix + Bouton */}
 <div className="omra-card__right">
 <div className="omra-card__price-block">
 <span className="omra-card__price-label">Prix par personne</span>
 <span className="omra-card__price">
 {price != null ? `${price.toFixed(0)} TND` : 'N/A'}
 </span>
 </div>
 <button className="omra-card__btn" onClick={() => openModal(event)}>
 Voir les détails
 </button>
 </div>

 </div>
 );
 })}
 </div>
 )}
 </div>
 </div>
 );
}

const css = `
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Playfair+Display:wght@700&display=swap');

/* ── BANNER ── */
.omra-banner {
 position: relative; height: 420px;
 background: url('/assets/img/banner-omra.jpg') center/cover no-repeat;
 display: flex; align-items: center; justify-content: center; overflow: hidden;
}
.omra-banner::before {
 content: ''; position: absolute; inset: 0; background: rgba(10, 30, 20, 0.21);
}
.omra-banner__overlay {
 position: absolute; inset: 0;
 background: radial-gradient(ellipse at center, transparent 50%, rgba(5,10,5,0.4) 100%);
}
.omra-banner__content {
 position: relative; z-index: 1; text-align: center;
 color: #fff; font-family: 'Inter', sans-serif;
}
.omra-banner__title {
 font-size: clamp(2rem, 5vw, 3rem); font-weight: 700;
 margin-bottom: 0.4rem; text-shadow: 0 2px 16px rgba(0,0,0,0.4);
 color: #ffffff;
 text-shadow: 0 2px 8px rgba(0,0,0,0.5);
}
.omra-banner__sub { font-size: 1.05rem; margin-bottom: 0.8rem; color: #ffffff; text-shadow: 0 1px 8px rgba(0,0,0,0.5); }
.omra-breadcrumb {
 list-style: none; display: flex; align-items: center;
 justify-content: center; gap: 0.4rem; padding: 0; margin: 0; font-size: 0.88rem;
}
.omra-breadcrumb a { color: rgba(255,255,255,0.85); text-decoration: none; }
.omra-breadcrumb__sep { opacity: 0.6; }
.omra-breadcrumb__active { font-weight: 600; }

/* ── MAIN ── */
.omra-section {
 max-width: 1100px; margin: 0 auto;
 padding: 3.5rem 1.5rem 4rem; font-family: 'Inter', sans-serif;
}
.omra-section__header { text-align: center; margin-bottom: 2.5rem; }
.omra-section__header h1 { font-size: clamp(1.5rem, 3vw, 2rem); margin-bottom: 0.5rem; }
.omra-section__header p { font-size: 1rem; }

/* ── FILTER ── */
.omra-filter {
 display: flex; align-items: center; justify-content: center; gap: 1rem;
 background: #f0f4fa; border: 1px solid #dde6f5; border-radius: 12px;
 padding: 1rem 1.5rem; margin-bottom: 2.5rem;
}
.omra-filter__label {
 font-family: 'Inter', sans-serif; font-weight: 600;
 color: #01225C; font-size: 0.95rem; white-space: nowrap;
}
.omra-filter__select {
 font-family: 'Inter', sans-serif; font-size: 0.9rem; color: #01225C;
 border: 1.5px solid #b8ccee; border-radius: 8px;
 padding: 0.45rem 0.9rem; background: #fff;
 outline: none; cursor: pointer; min-width: 220px;
}
.omra-filter__select:focus { border-color: #00338C; }

/* ── CARDS ── */
.omra-cards { display: flex; flex-direction: column; gap: 1.5rem; }

.omra-card {
 display: flex;
 border: 1px solid #E8E8E8;
 border-radius: 16px;
 overflow: hidden;
 background: #fff;
 box-shadow: 0 2px 16px rgba(0,0,0,0.06);
 transition: box-shadow 0.25s, transform 0.25s;
 min-height: 200px;
}
.omra-card:hover {
 box-shadow: 0 8px 28px rgba(0,51,140,0.1);
 transform: translateY(-2px);
}

/* Col 1 — Image 35% */
.omra-card__img-wrap {
 position: relative; flex-shrink: 0; width: 35%; overflow: hidden;
}
.omra-card__img {
 width: 100%; height: 100%; object-fit: cover; display: block;
 transition: transform 0.35s ease;
}
.omra-card:hover .omra-card__img { transform: scale(1.05); }
.omra-card__img-gradient {
 position: absolute; inset: 0;
 background: linear-gradient(to bottom, transparent 60%, rgba(0,0,0,0.25) 100%);
 pointer-events: none;
}

/* Col 2 — Contenu */
.omra-card__content {
 flex: 1;
 padding: 1.4rem 1.6rem;
 display: flex;
 flex-direction: column;
 gap: 0.8rem;
 justify-content: center;
}
.omra-card__title { font-size: 2rem; margin: 0; line-height: 1.3; }
.omra-card__desc { font-size: 0.88rem; margin: 0; }

/* Services inclus */
.omra-card__services {
 display: flex; align-items: center; justify-content: space-between;
 border: 1px solid #E8E8E8; border-radius: 8px;
 padding: 0.55rem 1rem; width: 100%;
}
.omra-card__services-left { display: flex; align-items: center; gap: 0.45rem; }
.omra-card__services-icon { color: #6C757D; font-size: 0.82rem; }
.omra-card__services-text {
 font-family: 'Inter', sans-serif; font-size: 0.84rem; font-weight: 400; color: #6C757D;
}
.omra-card__services-count {
 font-family: 'Inter', sans-serif; font-size: 0.84rem; font-weight: 700; color: #00338C;
}

/* Votre Voyage Inclut — label ligne 1, icônes ligne 2 */
.omra-card__includes {
 display: flex; flex-direction: column; align-items: flex-start; gap: 0.5rem;
}
.omra-card__includes-label {
 font-family: 'Inter', sans-serif; font-size: 0.88rem;
 font-weight: 600; color: #01225C; display: block;
}
.omra-card__includes-icons {
 display: flex; flex-direction: row; align-items: center; gap: 0.45rem;
}
.omra-card__icon-circle {
 width: 32px; height: 32px; border-radius: 50%;
 background: #FFF3CD;
 display: flex; align-items: center; justify-content: center;
 color: #FFBC1E; font-size: 0.8rem; flex-shrink: 0;
}

/* Col 3 — Prix en haut, bouton en bas avec padding */
.omra-card__right {
 flex-shrink: 0;
 width: 210px;
 display: flex;
 flex-direction: column;
 justify-content: space-between;
 border-left: 1px solid #E8E8E8;
 padding: 1.4rem 1.2rem 1.2rem;
 gap: 1rem;
}

/* Prix aligné en haut */
.omra-card__price-block {
 display: flex;
 flex-direction: column;
 align-items: flex-start;
 gap: 0.2rem;
}
.omra-card__price-label {
 font-family: 'Inter', sans-serif;
 font-size: 0.78rem; font-weight: 400; color: #6C757D;
}
.omra-card__price {
 font-family: 'Inter', sans-serif;
 font-size: 1.7rem; font-weight: 700; color: #003DA6; line-height: 1.1;
}

/* Bouton — normal, arrondi tous les coins, ne touche pas les bords */
.omra-card__btn {
 font-family: 'Inter', sans-serif;
 font-size: 0.92rem; font-weight: 700;
 color: #fff;
 background: #01225C;
 border: none;
 border-radius: 10px;
 padding: 0.85rem 1rem;
 cursor: pointer;
 width: 100%;
 text-align: center;
 transition: background 0.2s;
 margin-top: auto;
}
.omra-card__btn:hover { background: #001540; }

/* ── LOADING / EMPTY ── */
.omra-loading, .omra-empty {
 text-align: center; padding: 4rem 1rem;
 display: flex; flex-direction: column; align-items: center; gap: 1rem;
}
.omra-spinner {
 width: 40px; height: 40px;
 border: 3px solid #dde6f5; border-top-color: #00338C;
 border-radius: 50%; animation: omra-spin 0.8s linear infinite;
}
.omra-empty__icon { color: #b8ccee; margin-bottom: 0.5rem; }
@keyframes omra-spin { to { transform: rotate(360deg); } }

/* ── MODAL ── */
.omra-modal-backdrop {
 position: fixed; inset: 0; background: rgba(0,0,0,0.65);
 backdrop-filter: blur(4px); z-index: 1050;
 display: flex; align-items: center; justify-content: center; padding: 1rem;
}
.omra-modal-dialog {
 background: #fff; border-radius: 20px; width: 100%; max-width: 860px;
 max-height: 90vh; overflow: hidden; display: flex; flex-direction: column;
 box-shadow: 0 24px 64px rgba(0,0,0,0.3); font-family: 'Inter', sans-serif;
}
.omra-modal-header {
 display: flex; align-items: center; justify-content: space-between;
 padding: 1.2rem 1.6rem;
 background: linear-gradient(135deg, #01225C, #00338C);
 color: #fff; flex-shrink: 0;
}
.omra-modal-header__title { font-size: 1.1rem; font-weight: 700; margin: 0; }
.omra-modal-close {
 background: none; border: none; color: #fff;
 font-size: 1.2rem; cursor: pointer; opacity: 0.85; line-height: 1;
}
.omra-modal-close:hover { opacity: 1; }
.omra-modal-body { overflow-y: auto; padding: 1.8rem; flex: 1; }
.omra-modal-img-wrap {
 position: relative; border-radius: 12px; overflow: hidden; margin-bottom: 1.5rem;
}
.omra-modal-img { width: 100%; max-height: 320px; object-fit: cover; display: block; }
.omra-modal-img-overlay {
 position: absolute; bottom: 0; left: 0; right: 0; padding: 0.8rem 1rem;
 background: linear-gradient(to top, rgba(0,0,0,0.65), transparent);
 color: #fff; font-weight: 600; font-size: 0.9rem;
}
.omra-modal-departure {
 background: #f8faff; border: 1px solid #dde6f5;
 border-radius: 12px; padding: 1.2rem; margin-bottom: 1.2rem;
}
.omra-modal-departure__header {
 display: flex; justify-content: space-between; align-items: flex-start;
 margin-bottom: 1rem; flex-wrap: wrap; gap: 0.5rem;
}
.omra-badge {
 font-size: 0.78rem; font-weight: 600;
 padding: 0.3rem 0.8rem; border-radius: 999px; color: #fff;
}
.omra-badge--green { background: #198754; }
.omra-badge--red { background: #dc3545; }
.omra-modal-pricing { display: grid; grid-template-columns: 1fr 1fr; gap: 0.6rem; }
.omra-price-item {
 background: #fff; border: 1px solid #e4eaf5;
 border-radius: 8px; padding: 0.5rem 0.8rem; font-size: 0.87rem;
}
.omra-modal-section { margin-bottom: 1.4rem; }
.omra-modal-section__title {
 font-weight: 700; color: #01225C; font-size: 1rem; margin-bottom: 0.7rem;
}
.omra-modal-program {
 background: #eef6f1; border-left: 4px solid #00338C;
 border-radius: 10px; padding: 1rem 1.2rem;
}
.omra-modal-program p { font-size: 0.88rem; margin-bottom: 0.4rem; line-height: 1.7; }
.omra-modal-vol {
 background: #eef2fa; border-radius: 10px; padding: 0.9rem 1.1rem;
 font-size: 0.88rem; line-height: 1.7; color: #01225C;
}
.omra-modal-footer {
 display: flex; justify-content: flex-end; gap: 0.8rem;
 padding: 1rem 1.6rem; border-top: 1px solid #e8eef7; flex-shrink: 0;
}
.omra-btn {
 font-family: 'Inter', sans-serif; font-size: 0.92rem; font-weight: 600;
 border-radius: 10px; padding: 0.6rem 1.4rem; cursor: pointer; border: none;
 text-decoration: none; display: inline-flex; align-items: center; transition: all 0.2s;
}
.omra-btn--ghost { background: #f1f5fd; color: #01225C; border: 1px solid #dde6f5; }
.omra-btn--ghost:hover { background: #e4eaf5; }
.omra-btn--primary { background: #00338C; color: #fff; box-shadow: 0 4px 14px rgba(0,51,140,0.2); }
.omra-btn--primary:hover { background: #002a75; }
.omra-btn--disabled { background: #ced4da; color: #6c757d; cursor: not-allowed; }

/* ── RESPONSIVE ── */
@media (max-width: 768px) {
 .omra-card { flex-direction: column; }
 .omra-card__img-wrap { width: 100%; height: 200px; }
 .omra-card__right {
 width: 100%; flex-direction: row; border-left: none;
 border-top: 1px solid #E8E8E8; padding: 1rem 1.2rem;
 align-items: center;
 }
 .omra-card__price-block { flex: 1; }
 .omra-card__btn { width: auto; padding: 0.75rem 1.5rem; margin-top: 0; }
 .omra-filter { flex-direction: column; gap: 0.7rem; }
 .omra-modal-pricing { grid-template-columns: 1fr; }
}
`;